import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");
var TeacherOnboarding = require("lib/account/TeacherOnboarding");

require("users/teachers/onboarding_checklist_item.scss");

class OnboardingChecklistItem extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
		};
	}

	doItNow(e) {
		if (this.alreadyclicked) {
			return "";
		} else {
			this.alreadyclicked = true
			TeacherOnboarding.doIt(this.props.itemKey)
		}
	}

	render() {
		var itemKey = this.props.itemKey;

		if (this.props.isComplete) {
			var itemClassName = "complete";
			var itemImgPath = dynamicRequire("onboarding/icons/" + TeacherOnboarding.getImgPath(itemKey) + ".png");
			var callToAction = (
				<div className="completeText">
					Done!
				</div>
			);
		} else {
			var itemClassName = "incomplete";
			if (this.props.isNext) {
				itemClassName += " next"
			}
			if (this.props.hideActionLink) {
				var status = (
					<div>{ CurrentUser.get().completed_quiz_count } / 100 </div>
				)
			} else {
				var action = this.doItNow
				var callToAction = (
					<div>
						<a onClick={ action }>
							Do it Now
						</a>
					</div>
				);
			}
			var itemImgPath = dynamicRequire("onboarding/icons/" + TeacherOnboarding.getImgPath(itemKey) + "-gray.png");
		}

		return (
			<div className={ "onboardingChecklistItem " + itemClassName } onClick={action}>
				<div className="imageSection">
					<img src={ itemImgPath } alt={ itemKey } className="itemImg" />
				</div>
				<div className="infoSection">
					<div>
						{ TeacherOnboarding.getTitle(itemKey) }
					</div>
					{ callToAction }
					{ status }
				</div>
			</div>
		);
	}
}

OnboardingChecklistItem.propTypes = StrictPropTypes({
	itemKey: PropTypes.string.isRequired,
	isComplete: PropTypes.bool.isRequired,
	isNext: PropTypes.bool,
	hideActionLink: PropTypes.bool
});

module.exports = OnboardingChecklistItem;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingChecklistItem.js